<template>
    <div class="form-group row" :class="'form-field-' + nameDashed" :id="$_id" v-bind="rowAttrs" v-show="isVisible()">
        <div class="oc-view-label-column" v-class="viewLabelColumnClasses">
            <slot name="label" :scope="_self" v-if="displayLabel">
                <oc-label-input
                    v-if="labelText !== null"
                    v-text="labelText"
                    :for="$_inputId"
                    v-bind="labelAttrs"
                    class="form-control-label"
                    v-class="labelClasses"
                />

                <slot v-if="viewHelpUseIcon" name="help" :scope="_self">
                    <sup v-if="help !== null" :title="help" v-bind="helpAttrs" class="form-field-help form-field-help-question text-muted">
                        <oc-icon type="question-circle" />
                    </sup>
                </slot>
            </slot>
        </div>

        <div class="oc-view-value-column" v-class="viewValueColumnClasses">
            <div class="form-field-input-holder">
                <slot name="input" :scope="_self">
                    <oc-field
                        v-model="model"
                        v-on="inputListeners"
                        :id="$_inputId"
                        :placeholder="placeholderText"
                        :name="name"
                        v-bind="processedInputAttrs"
                        :readonly="isLoading || isReadonly()"
                        :disabled="isDisabled()"
                        v-class="inputClasses"
                        ref="input"
                    >
                        <template slot="view" slot-scope="viewAttrs">
                            <slot name="view" v-bind="viewAttrs"></slot>
                        </template>
                    </oc-field>
                </slot>

                <slot v-if="! viewHelpUseIcon" name="help" :scope="_self">
                    <i>
                        <small
                            v-if="help !== null"
                            class="form-field-help text-muted"
                            v-text="help"
                            v-bind="helpAttrs"
                        />
                    </i>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        viewHelpUseIcon: {
            type: Boolean,
            default: false
        },
        viewLabelColumnClasses: {
            type: [Array, Object, String],
            default: 'col-md-3'
        },
        viewValueColumnClasses: {
            type: [Array, Object, String],
            default: 'col-md-8'
        }
    },
    computed: {
        inputClasses() {
            let classes = {
                'is-invalid': false,
                'is-valid': false,
                'form-field-input': true
            }

            if( this.inputAttrs.class !== undefined ) {
                classes = [classes, this.inputAttrs.class]
            }

            return classes
        }
    }
}
</script>

<style scoped>
.form-group {
    margin-bottom: 0;
    margin-left: 0;
    margin-right: 0;
}

.form-group .oc-view-label-column,
.form-group .oc-view-value-column {
    padding-left: 8px;
    padding-right: 8px;
}

.form-group .form-field-help-question {
    color: #b1b1b1 !important;
    text-indent: 2px;
    font-size:15px;
    vertical-align: baseline;
}

.form-group .form-control-label {
    text-align: left;
    padding: 8px 0;
    margin-bottom: 0;
    display: inline-block;
    color: #4c5264;
    font-size: 14px;
    font-family: sans-serif;
}

.form-group .form-field-input-holder {
    padding: 8px 0;
}

.form-group .form-field-input {
    color: #4c5264;
    font-size: 14px;
    font-family: Verdana, SegoeUI-Semibold, Helvetica Neue, Arial, Helvetica;
}
</style>
